import { useQuery, useMutation } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { locations } from '../Locations';

type OptionsType = {
  enabled: boolean;
};

export const useLocations = (options?: OptionsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.location],
    queryFn: async () => (await locations.getLocations()).data,
    enabled: options?.enabled,
  });

export const useCreateLocation = () =>
  useMutation({ mutationFn: locations.createLocations });
export const useUpdateLocation = () =>
  useMutation({ mutationFn: locations.updateLocations });

export const useLocationsSites = (
  inspectionId: number,
  options?: {
    enabled?: boolean;
  },
) =>
  useQuery({
    queryKey: [QUERY_KEYS.location, inspectionId],
    queryFn: async () => (await locations.getLocationsSites(inspectionId)).data,
    enabled: options?.enabled,
  });

export const useLocationAW = (siteId?: number) =>
  useQuery({
    queryKey: [QUERY_KEYS.locationAW, siteId],
    queryFn: async () =>
      siteId ? (await locations.getLocationAW(siteId)).data : undefined,
    enabled: !!siteId,
  });
